module.exports = __webpack_public_path__ + "img/step1.f4aed75c.png";